import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { DialogActions, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useFormikContext } from 'formik';
import { LoadingButton } from '~/modules/common/components';
import { INPUT_FIELDS_MAP } from './hooks/useSetResourceAllocationOnChangeHandlers';
import useSetResourceAllocationPeriodError from './hooks/useSetResourceAllocationPeriodError';

const SetResourceAllocationDialogFooter = ({
  focusField,
  isSmartFitOpen,
  isSaving,
  onClose
}) => {
  const { handleSubmit } = useFormikContext();
  const { allocationError } = useSetResourceAllocationPeriodError();

  const isLoading = isSmartFitOpen || isSaving;
  const submitButtonRef = useRef(null);

  useEffect(() => {
    if (!isSmartFitOpen && focusField === INPUT_FIELDS_MAP.SUBMIT_BUTTON) {
      submitButtonRef.current?.focus();
    }
  }, [isSmartFitOpen, focusField]);

  return (
    <DialogActions>
      <Button
        data-qe-id="SetResourceAllocationDialog_CancelButton"
        disabled={isLoading}
        onClick={onClose}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.cancel" />
      </Button>
      <LoadingButton
        ref={submitButtonRef}
        color="primary"
        data-qe-id="SetResourceAllocationDialog_SubmitButton"
        disabled={isLoading || Boolean(allocationError)}
        isLoading={isLoading}
        onClick={handleSubmit}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.setResourceAllocation" />
      </LoadingButton>
    </DialogActions>
  );
};

SetResourceAllocationDialogFooter.propTypes = {
  focusField: PropTypes.string,
  isSmartFitOpen: PropTypes.bool,
  isSaving: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

export default SetResourceAllocationDialogFooter;
